// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"77f5131e","622":"361e3861"}[chunkId] + ".chunk.js";
};